import { extend, copyToClipboard } from "quasar";
import * as Sentry from "@sentry/vue";
import EventBus from "../event-bus";

class Utils {
  constructor() {}

  generateGuid = ():string => {
    const uuidv4 = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      
      return v.toString(16);
    })
    return uuidv4
  };

  clone = <T>(obj: T) => extend<T>(true, {}, obj);

  async copyToClipboard(text: string) {
    await copyToClipboard(text);
    EventBus.$emit("outSuccesMessage", { message: "Скопировано" });
  }

  downloadBuUrl(url: string) {
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.click();
  }

  preventLongPressMenu(event: any) {
    const e = event || window.event;
    e.preventDefault && e.preventDefault();
    e.stopPropagation && e.stopPropagation();
    e.cancelBubble = true;
    e.returnValue = false;
    return false;
  }

  formatTimeFromSeconds(_time: any, format = "hh:mm:ss.ms") {
    const pad = (num: number, size: number) => ("000" + num).slice(size * -1);
    const time = parseFloat(parseFloat(_time).toFixed(3)),
      hours = Math.floor(time / 60 / 60),
      minutes = Math.floor(time / 60) % 60,
      seconds = Math.floor(time - minutes * 60),
      milliseconds = time.toString().slice(-3);

    const format_array = format.split(":").map((unit) => {
      if (unit == "hh") return pad(hours, 2);
      if (unit == "mm") return pad(minutes, 2);
      if (unit == "ss.ms") return pad(seconds, 2) + "." + milliseconds;
      if (unit == "ss") return pad(seconds, 2);
    });

    return format_array.join(":");
  }

  calculateLineHeadPosition(ev: any, element: any) {
    const progressWidth = element.getBoundingClientRect().width;
    const leftPosition = ev.target.getBoundingClientRect().left;
    let pos = (ev.clientX - leftPosition) / progressWidth;

    try {
      if (!ev.target.className.match(/^ar\-line\-control/)) {
        return;
      }
    } catch (error) {
      Sentry.captureException(error);
      return;
    }

    pos = pos < 0 ? 0 : pos;
    pos = pos > 1 ? 1 : pos;

    return pos;
  }

  convertTimeMMSS(seconds: number) {
    return new Date(seconds * 1000).toISOString().substr(14, 5);
  }

  getRandomIntInclusive(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min; //Максимум и минимум включаются
  }

  map(
    elems: any,
    f = (elem: any, i: any) => elem,
    cond = (elem: any, i: any) => true
  ) {
    const tmp = [];
    for (const i in elems) {
      const elem = elems[i];
      if (cond(elem, i)) {
        tmp.push(f(elem, i));
      }
    }
    return tmp;
  }

  findAndCutMarkers(text: string) {
    const settings = (window as any).$store.getters["settings/allSettings"];
    const markers = settings.sendMessageOnFinalizeMarker;
    // (^|[^а-яё])(юля)($|[^а-яё])
    // (?<=\s|^)(юля)(?=\s|$)
    // "Юля ЮЛЯ юля пришла с Июля вместе с юляшкой моя юля" => "пришла с Июля вместе с юляшкой моя"
    const re = new RegExp(`(^|[^а-яё\w])(${markers})($|[^а-яё\w])`, "ig");
    return {
      result: !markers.length || re.test(text),
      text: text
        .replace(/\s/g, "  ")
        .replace(re, " ")
        .replace(/\s+/g, " ")
        .trim(),
    };
  }
}

export default new Utils();
